import { render, staticRenderFns } from "./SettingPage.vue?vue&type=template&id=9e910254&scoped=true"
import script from "./SettingPage.vue?vue&type=script&lang=js"
export * from "./SettingPage.vue?vue&type=script&lang=js"
import style0 from "./SettingPage.vue?vue&type=style&index=0&id=9e910254&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e910254",
  null
  
)

export default component.exports